import { render, staticRenderFns } from "./Resident.vue?vue&type=template&id=52b5efb0&scoped=true&"
import script from "./Resident.vue?vue&type=script&lang=js&"
export * from "./Resident.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/userprofile.css?vue&type=style&index=0&id=52b5efb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b5efb0",
  null
  
)

export default component.exports